import "./style.scss";
import {
	Grid,
	Container,
	Breadcrumbs,
	Typography,
	Box,
} from "@material-ui/core";
import { Translator } from "@itarget/shared";
import CardDetailCourse from "../../../components/CardDetailCourse";
import Layout from "../../../components/Layout";
import ModalVideoCourse from "../../../components/ModalVideoCourse";
import ModalQuestionsCourse from "../../../components/ModalQuestionsCourse";
import ProgramingOnDemand from "../../../components/ProgramingOnDemand";
import TotalAssisted from "../../../components/ButtonsOnDemand/TotalAssisted";
import AboutCourse from "../../../components/ButtonsOnDemand/AboutCourse";
import Quiz from "../../../components/ButtonsOnDemand/Quiz";
import QuestionnaireNote from "../../../components/ButtonsOnDemand/QuestionnaireNote";
import ViewCertificate from "../../../components/ButtonsOnDemand/ViewCertificate";
import ComplementaryFile from "../../../components/ButtonsOnDemand/ComplementaryFile";
import { Alert } from "@material-ui/lab";
import { ModalIframeCourse } from "../../../components/ModalIframeCourse/ModalIframeCourse";
import ProgramingOnDemandGrouped from "../../../components/ProgramingOnDemand/ProgramingOnDemandGrouped";
import DisplayValuesOffers from "../../../components/DisplayValues​Offers";
import QuizResultsModal from "../../../components/QuizResultsModal";

const DetailMyCourseGrouped = ({
	id,
	isLoading,
  isLoadingDetail,
	selectStep,
  totalWatch,
	showVideo,
	showQuiz,
  showAnswers,
	closeShowVideo,
  closeShowAnswers,
	canControlVideoProgressBar,
	onPause,
	onPlay,
	onProgress,
	onEnded,
	refPlayer,
	detail,
	lesson,
	speakers,
	polls,
	isVideoInsideVideoPolls,
	closeShowQuiz,
	setOpenPoll,
	setOpenCertificate,
	percentNextVideo,
	secondsLeft,
	secondsLeftQuiz,
	limitTimeQuiz,
	playing,
	onEndQuizCallback,
  ondemandFormat,
  defaultModule,
  detailRequest,
  openQuestionFromCurrentLessonWithQuestionId,
  quizResults,
  isLoadingQuizResults,
  onOpenSubmodule,
  finalResultsByScheduleId,
  isLoadingFinalResult,
  settingCommerce,
  loadFinalResultsOnEachItem,
	showIframe,
	handleModalIframe,
}) => {
  const translation = {
    OnDemand: Translator({
      transRef: "OnDemand",
    }),
    timeWarning: Translator({
      transRef:
        "translation.Atenção: a resolução dos questionários e a visualização das videoaulas têm tempo limitado. Tenha certeza de que, uma vez iniciada a visualização das aulas, as mesmas sejam concluídas dentro do prazo estipulado.",
    }),
    content: Translator({
      transRef: "Conteúdo",
    }),
  };

  return (
    <Layout isLoading={isLoading} bodyClassname="detailMyCourseGroupedLayout">
			{showIframe && <ModalIframeCourse lesson={lesson} handleModalIframe={handleModalIframe}  />}
      {showVideo && (
        <ModalVideoCourse
          playing={playing}
          refPlayer={refPlayer}
          onProgress={onProgress}
          onPause={onPause}
          lesson={lesson}
          speakers={speakers}
          closeShowVideo={closeShowVideo}
          onPlay={onPlay}
          onEnded={onEnded}
          secondsLeft={secondsLeft}
          playerOptions={{
            progress_bar:
              detailRequest?.data?.detailing?.[0]?.exibe_controle_video,
          }}
          totalWatch={totalWatch}
        />
      )}
      {showQuiz && !secondsLeftQuiz && (
        <ModalQuestionsCourse
          polls={polls}
          canClosePoll={!isVideoInsideVideoPolls}
          secondsLeftQuiz={secondsLeftQuiz}
          limitTimeQuiz={limitTimeQuiz}
          closeShow={closeShowQuiz}
          onEndQuizCallback={onEndQuizCallback}
        />
      )}
      {showQuiz && secondsLeftQuiz && (
        <ModalQuestionsCourse
          polls={polls}
          canClosePoll={!isVideoInsideVideoPolls}
          secondsLeftQuiz={secondsLeftQuiz}
          limitTimeQuiz={limitTimeQuiz}
          closeShow={closeShowQuiz}
          onEndQuizCallback={onEndQuizCallback}
        />
      )}
      {showAnswers && (
        <QuizResultsModal
          results={quizResults}
          isLoading={isLoadingQuizResults}
          closeShow={closeShowAnswers}
          course={lesson}
          finalResultsByScheduleId={finalResultsByScheduleId}
          isLoadingFinalResult={isLoadingFinalResult}
        />
      )}

      <Grid container>
        {detail ? (
          <Breadcrumbs style={{ marginTop: 15, padding: 24 }} separator="›">
            {[
              <div
                onClick={() => window.history.back()}
                style={{ cursor: "pointer", fontWeight: "bold" }}
              >
                <Translator transRef="translation.Ofertas" />
              </div>,
              <div style={{ fontSize: 12 }}>{translation.OnDemand}</div>,
            ]}
          </Breadcrumbs>
        ) : null}
        {detail?.data?.controle_tempo && (
          <Grid>
            <Alert severity="error">
              <div
                dangerouslySetInnerHTML={{
                  __html: translation.timeWarning.props.children,
                }}
              ></div>
            </Alert>
          </Grid>
        )}
        {!detail && !isLoading ? (
          <Grid container alignItems="center" justifyContent="center">
            <Typography>
              <Translator transRef={`translation.Sem permissão`} />
            </Typography>
          </Grid>
        ) : (
          <Grid container className="grid-containerDetail" spacing={4} xs={12}>
            {ondemandFormat && (
              <Grid className="grid-datas" item sm={12} md={9}>
                <Grid className="detailOffer-background">
                  <Grid className="detailOffer-cardOffers">
                    <CardDetailCourse detail={detail} />
                  </Grid>
                </Grid>
                <DisplayValuesOffers.Header
                  title={translation.content}
                  style={{ margin: "20px 0" }}
                />
                {ondemandFormat === 1 && (
                  <ProgramingOnDemand
                    programingGrouped={detail}
										handleModalIframe={handleModalIframe}
                    value={0}
                    selectStep={selectStep}
                    steps={detail && detail.data ? detail.data.list : []}
                    percentNextVideo={percentNextVideo}
                    loadFinalResults={loadFinalResultsOnEachItem}
                    openQuestionFromCurrentLessonWithQuestionId={
                      openQuestionFromCurrentLessonWithQuestionId
                    }
                    finalResultsByScheduleId={finalResultsByScheduleId}
                    settingCommerce={settingCommerce}
                    isLoadingDetail={isLoadingDetail}
                  />
                )}
                {ondemandFormat === 2 && (
                  <ProgramingOnDemandGrouped
                    groups={detail?.data?.list}
                    handleModalIframe={handleModalIframe}
                    selectStep={selectStep}
                    defaultModule={defaultModule}
                    openQuestionFromCurrentLessonWithQuestionId={
                      openQuestionFromCurrentLessonWithQuestionId
                    }
                    onOpenSubmodule={onOpenSubmodule}
                    finalResultsByScheduleId={finalResultsByScheduleId}
                    isLoadingFinalResult={isLoadingFinalResult}
                    settingCommerce={settingCommerce}
                    isLoadingDetail={isLoadingDetail}
                  />
                )}
              </Grid>
            )}
            <Grid className="grid-datas" item sm={12} md={3}>
              {detailRequest?.data?.detailing && (
                <DisplayValuesOffers.Header
                  title={
                    detailRequest?.data?.detailing?.[0]?.desc_atv ||
                    detailRequest?.data?.detailing?.[0]?.desc_tatv
                  }
                  activityType={detailRequest?.data?.detailing?.[0]?.desc_tatv}
                />
              )}
              <TotalAssisted
                total_assistido={
                  detail && detail.data ? detail.data.total_assistido : 0
                }
              />
              <Box marginTop={2}>
                <Grid container spacing={2}>
                  {detailRequest?.data?.detailing?.[0]?.informe_ondemand && (
                    <Grid item>
                      <Alert severity="info">
                        {detailRequest?.data?.detailing?.[0]?.informe_ondemand}
                      </Alert>
                    </Grid>
                  )}
                  <AboutCourse agenda_atividade_id={id} />
                  {detail?.data?.arquivo &&
                    detail?.data?.arquivo.length > 0 && (
                      <ComplementaryFile files={detail?.data?.arquivo} />
                    )}
                  {detail?.data?.perguntas?.exibir_questionario && (
                    <Quiz setOpenPoll={setOpenPoll} />
                  )}
                  {detail?.data?.resposta_correta > 0 && (
                    <QuestionnaireNote
                      exibir_certificado={detail?.data?.exibir_certificado}
                      resposta_correta={detail.data.resposta_correta}
                    />
                  )}
                  {detail?.data?.exibir_certificado && (
                    <ViewCertificate
                      setOpenCertificate={setOpenCertificate}
                      url_certificado={detail?.data?.url_certificado}
                    />
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};

export default DetailMyCourseGrouped;
